module.exports = __webpack_public_path__ + "media/svg/aw-2ee03c54.svg";